import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ActivationPlacementExamOverlayComponent } from './activation-placement-exam-overlay/activation-placement-exam-overlay.component';
import { SharedModule } from '../shared/shared.module';
import { ActivationPlacementExamModalComponent } from './activation-placement-exam-modal/activation-placement-exam-modal.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ActivationPlacementExamOverlayComponent, ActivationPlacementExamModalComponent],
  exports: [ActivationPlacementExamOverlayComponent],
  entryComponents: [ActivationPlacementExamModalComponent],
})
export class OverlayModule {}



// WEBPACK FOOTER //
// ./ts/app/overlay/overlay.module.ts